<div class="bulk-container whitespace-nowrap">
  <ng-container *ngIf="getItemsSelectedData('items') as selectedItems">
    <button
      *ngIf="showEditButton"
      (click)="openMenu($event)"
      #bulkMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="bulkMenu"
      mat-flat-button
      class="bulk-button button-primary"
      type="button"
      [disabled]="selectedItems.length ? false : true"
    >
      <mat-icon class="material-icons-outlined">checklist</mat-icon>
      {{ buttonText }}
    </button>
    <div class="checkbox-container" *ngIf="showSelectAllCheckbox && selectAllAccessibility()" [matTooltip]="assetCount > 500 ? max500Tooltip : ''">
      <mat-checkbox
        *ngIf="!selectedItems?.length"
        [indeterminate]="selectedItems.length ? true : false"
        id="toggle-select-all"
        class="example-margin ml-2"
        [checked]="selectedItems.length ? true : false"
        (change)="toggleSelectAllCheckbox.emit($event)"
        [disabled]="assetCount === 0 || assetCount > 500"
      ></mat-checkbox>
      <mat-checkbox
        *ngIf="selectedItems?.length"
        [indeterminate]="selectedItems.length === assetCount ? false : true"
        id="toggle-select-all"
        class="example-margin ml-2"
        [checked]="selectedItems.length ? true : false"
        (change)="bulkEditType === 'assets' ? clickUnselectAll() : toggleSelectAllCheckbox.emit($event)"
      ></mat-checkbox>
      <!-- Attention: mat-checkbox automatically adds "-input" to any given id -->
      <label
        *ngIf="['assets', 'collection', 'collections'].includes(bulkEditType) && !selectedItems?.length"
        for="toggle-select-all-input"
        class="pr-2 whitespace-nowrap"
        [ngClass]="assetCount === 0 || assetCount > 500 ? 'text-gray-500' : ''"
        i18n
        >Select all</label
      >
      <!-- Attention: mat-checkbox automatically adds "-input" to any given id -->
      <label *ngIf="['assets', 'collection', 'collections'].includes(bulkEditType) && selectedItems.length > 0" class="pr-2" for="toggle-select-all-input">
        <ng-container i18n>Unselect all</ng-container>&nbsp;<span class="amount">({{ selectedItems.length }})</span>
      </label>
      <span *ngIf="bulkEditType === 'basket'" class="px-2"
        ><ng-container i18n>Unselect all</ng-container>&nbsp;<span class="amount">({{ selectedItems.length }})</span></span
      >
    </div>
    <mat-menu #bulkMenu="matMenu" class="bulk-menu">
      <ng-template matMenuContent>
        <ng-container>
          <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
            <button mat-menu-item (click)="updateAssetOnDraft()" *ngIf="allDraftAssets && bulkEditType !== 'collections' && (AnyAsset | can: 'update')" class="edit-metadata-button edit-button">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span i18n>Edit Asset</span>
            </button>
            <button mat-menu-item (click)="editAssets('metaData')" *ngIf="!allDraftAssets && bulkEditType !== 'collections' && (AnyAsset | can: 'update')" class="edit-metadata-button edit-button">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span i18n>Edit metadata</span>
            </button>
            <button
              mat-menu-item
              (click)="editAssets('usageRights')"
              *ngIf="!allDraftAssets && bulkEditType !== 'collections' && (AnyAsset | can: 'usagerights')"
              class="edit-usage-rights-button edit-button"
            >
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span i18n>Edit usage rights</span>
            </button>
            <button
              mat-menu-item
              (click)="editAssets('relations')"
              *ngIf="!allDraftAssets && bulkEditType !== 'collections' && (AnyAsset | can: 'relations')"
              class="edit-relations-button edit-button"
            >
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span i18n>Edit relations</span>
            </button>
            <button
              mat-menu-item
              (click)="exportAssets()"
              [attr.data-test-id]="'assets_button-export'"
              [disabled]="showEmptyState"
              *ngIf="!allDraftAssets && (AnyReport | can: 'export.metadata') && assetCount > 0"
            >
              <mat-icon class="material-icons-outlined">drive_file_move</mat-icon>
              <span class="whitespace-nowrap" i18n>Export asset info</span>
            </button>
            <button mat-menu-item (click)="exportDownloads()" *ngIf="!allDraftAssets && bulkEditType !== 'collections' && (AnyReport | can: 'export.downloads')">
              <mat-icon class="material-icons-outlined">drive_file_move</mat-icon>
              <span i18n>Export downloads</span>
            </button>
          </ng-container>
          <button
            mat-menu-item
            (click)="downloadAssets()"
            *ngIf="
              !allDraftAssets &&
              ((!['collection', 'collections'].includes(bulkEditType) && (AnyAsset | can: 'download')) ||
                (bulkEditType === 'collection' && assetCount !== selectedItems?.length && (AnyAsset | can: 'download')))
            "
            class="download-asset-button"
          >
            <mat-icon class="material-icons-outlined">file_download</mat-icon>
            <span
              ><ng-container *ngIf="brandingKey !== CustomClients.VKB" i18n>Download assets</ng-container> <ng-container *ngIf="brandingKey === CustomClients.VKB" i18n>Download</ng-container></span
            >
          </button>

          <ng-container *ngIf="!allDraftAssets">
            <button mat-menu-item (click)="downloadAssets()" *ngIf="!allDraftAssets && ((bulkEditType === 'collection' && assetCount === selectedItems?.length) || bulkEditType === 'collections')">
              <mat-icon class="material-icons-outlined">file_download</mat-icon>
              <span i18n>Download collection</span>
            </button>
          </ng-container>

          <button
            mat-menu-item
            (click)="shareAssets()"
            *ngIf="
              !allDraftAssets &&
              ((!['collection', 'collections'].includes(bulkEditType) && (AnyAsset | can: 'share')) ||
                (bulkEditType === 'collection' && (AnyAsset | can: 'share') && assetCount !== selectedItems?.length))
            "
            class="share-asset-button"
          >
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span i18n>Share assets</span>
          </button>

          <button
            mat-menu-item
            (click)="shareCollection.emit()"
            *ngIf="!allDraftAssets && (((AnyAsset | can: 'share') && bulkEditType === 'collection' && assetCount === selectedItems?.length) || bulkEditType === 'collections')"
            class="share-collection-button"
          >
            <mat-icon class="material-icons-outlined">share</mat-icon>
            <span i18n>Share collection</span>
          </button>

          <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
            <button
              mat-menu-item
              (click)="addToCollection()"
              *ngIf="!allDraftAssets && !['collection', 'collections'].includes(bulkEditType) && (AnyAsset | can: 'collection.create')"
              class="add-to-collection-button"
            >
              <mat-icon class="material-icons-outlined">perm_media</mat-icon>
              <span i18n>Add to collection</span>
            </button>
            <button mat-menu-item (click)="clickClearBasket.emit()" *ngIf="!allDraftAssets && bulkEditType === 'basket'" class="remove-from-basket-button">
              <mat-icon class="material-icons-outlined">remove_shopping_cart</mat-icon>
              <span i18n>Remove from basket</span>
            </button>

            <button mat-menu-item (click)="deleteSelectedAssets(false)" *ngIf="!['collection', 'collections'].includes(bulkEditType) && (AnyAsset | can: 'delete')" class="delete-asset-button">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span i18n>Delete assets</span>
            </button>
            <button
              mat-menu-item
              (click)="deleteSelectedAssets(true)"
              *ngIf="!allDraftAssets && !['collection', 'collections'].includes(bulkEditType) && (AnyAsset | can: 'plandeletion')"
              class="plan-deletion-button"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span i18n>Plan deletion</span>
            </button>
            <button
              mat-menu-item
              (click)="addToDashboard.emit()"
              *ngIf="
                (Globally | can: 'dashboard.editcollection') &&
                collectionPublished &&
                (brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge) &&
                ['collection', 'collections'].includes(bulkEditType) &&
                assetCount === selectedItems?.length
              "
              class="add-to-dashboard-button"
            >
              <mat-icon class="material-icons-outlined">dashboard</mat-icon>
              <span i18n>Add to dashboard</span>
            </button>
            <button mat-menu-item (click)="removeFromCollection()" *ngIf="['collection', 'collections'].includes(bulkEditType) && collectionOwner" class="remove-from-collection-button">
              <mat-icon class="material-icons-outlined">{{ [CustomClients.Vorwerk].includes(brandingKey) ? 'gallery_off' : 'folder_off' }}</mat-icon>
              <span i18n>Remove from collection</span>
            </button>
            <button
              mat-menu-item
              (click)="publishCollection.emit()"
              *ngIf="['collection', 'collections'].includes(bulkEditType) && !collectionPublished && collectionOwner && (AnyAsset | can: 'collection.publish')"
              [disabled]="bulkEditType === 'collection' && assetCount !== selectedItems.length"
              class="publish-collection-button"
            >
              <mat-icon class="material-icons-outlined">feed</mat-icon>
              <span i18n>Publish collection</span>
            </button>
            <button
              mat-menu-item
              (click)="unpublishCollection.emit()"
              *ngIf="['collection', 'collections'].includes(bulkEditType) && collectionPublished && collectionOwner && (AnyAsset | can: 'collection.publish')"
              [disabled]="bulkEditType === 'collection' && assetCount !== selectedItems.length"
              class="unpublish-collection-button"
            >
              <mat-icon class="material-icons-outlined">feed</mat-icon>
              <span i18n>Unpublish collection</span>
            </button>
            <button
              mat-menu-item
              (click)="deleteCollection.emit()"
              *ngIf="['collection', 'collections'].includes(bulkEditType) && collectionOwner"
              [disabled]="bulkEditType === 'collection' && assetCount !== selectedItems.length"
              class="delete-collection-button"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span i18n>Delete collection</span>
            </button>
          </ng-container>
        </ng-container>
      </ng-template>
    </mat-menu>
  </ng-container>
</div>
